export const workspace = [
    {
        name: 'workspace',
        path: '/workspace',
        redirect: {
            name: 'task-center',
        },
        component: () => import(/* webpackChunkName: "workspace" */ '../../views/workspace/Workspace/Workspace.vue'),
        children: [
            {
                name: 'task-center',
                path: 'task-center',
                component: () => import(/* webpackChunkName: "workspace" */ '../../views/workspace/TaskCenter/TaskCenter.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'backoffice.nav.workspace',
                        },
                        {
                            text: 'backoffice.nav.task_center',
                            active: true,
                        }
                    ],
                    permission: 'TaskCenter',
                },
            },
            {
                name: 'task-analysis',
                path: 'task-analysis',
                component: () => import(/* webpackChunkName: "workspace" */ '../../views/workspace/TaskAnalysis/TaskAnalysis.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'backoffice.nav.workspace',
                        },
                        {
                            text: 'backoffice.nav.task_analysis',
                            active: true,
                        }
                    ],
                },
            }
        ],
    },
    {
        name: 'data-analysis',
        path: '/workspace/data-analysis',
        component: () => import(/* webpackChunkName: "workspace" */ '../../views/workspace/DataAnalysis/DataAnalysis.vue'),
        props: true,
        meta: {
            breadcrumb: [
                {
                    text: 'backoffice.nav.operation_tool',
                },
                {
                    text: 'backoffice.nav.workspace',
                },
                {
                    text: 'backoffice.nav.data_analysis',
                    active: true,
                }
            ],
        },
    },
    /* 数据迁移 */
    {
        name: 'data-migration',
        path: '/workspace/data-migration',
        component: () => import(/* webpackChunkName: "workspace" */ '../../views/workspace/DataMigration/DataMigration.vue'),
        props: true,
        meta: {
            breadcrumb: [
                {
                    text: 'backoffice.nav.operation_tool',
                },
                {
                    text: 'backoffice.nav.workspace',
                },
                {
                    text: 'backoffice.nav.data_migration',
                    active: true,
                }
            ],
            permission: 'DataMigration',
        },
    },
    {
        name: 'separateData',
        path: '/workspace/separate-data',
        redirect: {
            name: 'separateDataManagement',
        },
        component: () => import(/* webpackChunkName: "workspace" */ '../../views/workspace/SeparateData/SeparateData.vue'),
        children: [
            {
                name: 'separateDataManagement',
                path: 'separate-data-management',
                component: () => import(/* webpackChunkName: "workspace" */ '../../views/workspace/SeparateDataManagement/SeparateDataManagement.vue'),
                props: true,
                meta: {
                    keepAlive: false,
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'backoffice.nav.workspace',
                        },
                        {
                            text: 'backoffice.nav.separate_data',
                        },
                        {
                            text: 'backoffice.nav.separate_data_management',
                            active: true,
                        }
                    ],
                },
            }
        ],
    }
];
